export const VALID_PL_BILL_DETAILS_TYPES = {
    SEPARATOR: "separator",
    DISPLAY: "display",
    TOOLTIP: "tooltip",
    BANNER: "banner",

    // sub-item types
    TITLE: "title",
    ICON: "icon",
    TEXT: "text",
    BUTTON: "button",
} as const;
